import { render, staticRenderFns } from "./StclPL.vue?vue&type=template&id=53dd0b9a"
import script from "./StclPL.vue?vue&type=script&lang=js"
export * from "./StclPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports